import { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Grid, LinearProgress } from '@mui/material';
import {
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  styled,
  Stack,
} from '@mui/material';
import { collecionFormValidation } from '../../utils/videoFormValidationUtils';
import { getMediaById, getCollectionById } from './Resources';
import { useAppProviderStore } from 'store/appProviderCopyStore';
import { useNotification } from 'hooks/useNotification';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';

function SeriesStep7(props) {
  const {
    setValue,
    formValidation,
    activeStep,
    viewFields,
    setCollectionResponse,
    getValues,
    collectionResponse,
    // isLoading
  } = props;
  const [showContainer, setShowContainer] = useState(props.activeStep);
  // const [showContainer] = useState(props.activeStep);
  const [visibility, setVisibility] = useState('');
  const [showStatus, setShowStatus] = useState('');
  const [, setSelectedVisibilityLabel] = useState(null);
  const [userProfile, setUserProfile] = useState();
  const [disableButton, setDisableButton] = useState(false);
  const { setNotify } = useNotification();
  const [auth, setAuth] = useOutletContext();
  const {
    trailerUploadProgress,
    legendaTrailerUploadProgress,
    audioTrailerUploadProgress,
  } = useAppProviderStore();
  // const [isFullDescription, setIsFullDescription] = useState(false);
  // const [isComments, setIsComments] = useState(false);
  // const [isShortDescription, setIsShortDescription] = useState(false);

  // const maxLengthSeeMore = 50;

  useEffect(() => {
    setUserProfile(auth.getIdToken().payload['custom:user_profile']);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let flag = true;
    if (props.activeStep === 7) {
      if (flag) {
        (async () => {
          let trailerId = getValues('trailerId');
          if (trailerId) {
            let path = `/${trailerId}`;
            let responseTrailer = await getMediaById(
              path,
              auth,
              trailerId,
              setAuth,
              setNotify
            );
            setShowStatus(responseTrailer?.status);
          }
          let path = `/${getValues('id')}/versions/${getValues('version')}`;
          await getCollectionById(path, auth, setAuth, setNotify);
        })();
      }
    }

    return () => {
      flag = false;
    };
  }, [props.activeStep]);

  useEffect(() => {
    setCollectionResponse(getValues());
    setShowContainer(props.activeStep);
    setVisibility(collectionResponse?.visibility);
    setValue('visibility', collectionResponse?.visibility);

    for (let item of visibilities) {
      if (collectionResponse?.visibility === item.name) {
        setSelectedVisibilityLabel(item.value);
        setValue('visibility', item.name);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.activeStep, showContainer]);
  
  // const disableButton = useMemo(() => {
  //   if (["18", "A18"].includes(collectionResponse?.ageRating) 
  //         || collectionResponse?.ageRating === 0 ) {
  //     return true;
  //   }
  // }, [collectionResponse?.ageRating]);

  useEffect(() => {
    if (["18", "A18"].includes(collectionResponse?.ageRating)) {
      setDisableButton(true);
    } else {
      setDisableButton(false);
    }
  }, [collectionResponse]);


  const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: '50%',
    width: 16,
    height: 16,
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 0 0 1px rgb(16 22 26 / 40%)'
        : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
    backgroundImage:
      theme.palette.mode === 'dark'
        ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
        : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background:
        theme.palette.mode === 'dark'
          ? 'rgba(57,75,89,.5)'
          : 'rgba(206,217,224,.5)',
    },
  }));

  const visibilities = [
    {
      name: 'INTERNAL_USERS',
      value: 'Somente para usuários internos (para validação prévia - preview)',
    },
    { name: 'AUTHENTICATED_USERS', value: 'Somente para usuários logados' },
    { name: 'EVERYONE', value: 'Todos usuários (Logados e não-logados)' },
  ];

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#137cbd',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  });

  function BpRadio(props) {
    return (
      <Radio
        disableRipple
        style={{ padding: 8 }}
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        {...props}
      />
    );
  }

  const handleVisibilityChange = event => {
    const {
      target: { value },
    } = event;
    setVisibility(value);
    setValue('visibility', value);
    for (let item of visibilities) {
      if (value === item.name) {
        setSelectedVisibilityLabel(item.value);
      }
    }
  };

  const verifyUpload = () => {
    if (
      trailerUploadProgress?.percent > 0 &&
      trailerUploadProgress?.percent < 100
    ) {
      return true;
    } else if (
      legendaTrailerUploadProgress?.percent > 0 &&
      legendaTrailerUploadProgress?.percent < 100
    ) {
      return true;
    } else if (
      audioTrailerUploadProgress?.percent > 0 &&
      audioTrailerUploadProgress?.percent < 100
    ) {
      return true;
    } else {
      return false;
    }
  };

  // const showAllText = val => {
  //   if (val === 'shortDescription') {
  //     setIsShortDescription(!isShortDescription);
  //     return isShortDescription;
  //   }
  //   if (val === 'fullDescription') {
  //     setIsFullDescription(!isFullDescription);
  //     return isFullDescription;
  //   }
  //   if (val === 'comments') {
  //     setIsComments(!isComments);
  //     return isComments;
  //   }
  //   return false;
  // };

  return (
    <div
      className={activeStep === 7 ? 'step-container' : 'step-container hidden'}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="video_label-title">Publicação</div>
        </Grid>

        <Grid item xs={12}>
          <FormControl>
            <FormLabel
              id="demo-radio-buttons-group-label"
              className="form-label">
              Visibilidade da publicação
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              onChange={ e => {
                handleVisibilityChange(e)
              } }
              value={visibility || ''}
              id="collection-visibility">
              <FormControlLabel
                disabled={viewFields}
                key={0}
                value="INTERNAL_USERS"
                control={<BpRadio />}
                label="Somente para usuários do Portal Admin do APP (para validação prévia - preview)"
                id="collection-visibility-internal"
              />
              {userProfile === 'ADMIN' && (
                <FormControlLabel
                  disabled={viewFields}
                  key={1}
                  value="AUTHENTICATED_USERS"
                  control={<BpRadio />}
                  label="Somente para usuários do APP logados"
                  id="collection-visibility-authenticated-user"
                />
              )}
              {userProfile === 'ADMIN' && (
                <FormControlLabel
                  disabled={viewFields || disableButton}
                  key={2}
                  value="EVERYONE"
                  control={<BpRadio />}
                  label="Todos usuários do APP (Logados e não-logados)"
                  id="collection-visibility-everyone"
                />
              )}
            </RadioGroup>
          </FormControl>
          {disableButton  && (
            <Grid item xs={12}>
              <div className="video_label-title">
                <p style={{ fontSize: '15px' }}>
                  * Conteúdo para maior de 18 anos, opção válida somente para
                  usuários logados ou Preview
                </p>
              </div>
            </Grid>
          )}
        </Grid>

        {verifyUpload() && (
          <Grid item xs={12}>
            <div className="video_label-title">
              Arquivos em processo de upload. Aguarde...
            </div>

            <ul className="steps_resumo" id="video-summary">
              {trailerUploadProgress?.percent > 0 &&
                trailerUploadProgress?.percent < 100 && (
                  <li id="video-summary-title">
                    Trailer:{' '}
                    <Stack
                      sx={{
                        width: '100%',
                        color: 'grey.500',
                        padding: '15px',
                      }}
                      spacing={2}>
                      <label>{trailerUploadProgress?.name}</label>
                      <LinearProgress
                        color="secondary"
                        variant="determinate"
                        value={trailerUploadProgress?.percent}
                      />
                    </Stack>
                  </li>
                )}

              {legendaTrailerUploadProgress?.percent > 0 &&
                legendaTrailerUploadProgress?.percent < 100 && (
                  <li id="video-summary-title">
                    Legenda(s) do trailer:{' '}
                    <Stack
                      sx={{
                        width: '100%',
                        color: 'grey.500',
                        padding: '15px',
                      }}
                      spacing={2}>
                      <label>{legendaTrailerUploadProgress?.name}</label>
                      <LinearProgress
                        color="secondary"
                        variant="determinate"
                        value={legendaTrailerUploadProgress?.percent}
                      />
                    </Stack>
                  </li>
                )}

              {audioTrailerUploadProgress?.percent > 0 &&
                audioTrailerUploadProgress?.percent < 100 && (
                  <li id="video-summary-title">
                    Áudio do trailer:{' '}
                    <Stack
                      sx={{
                        width: '100%',
                        color: 'grey.500',
                        padding: '15px',
                      }}
                      spacing={2}>
                      <label>{audioTrailerUploadProgress?.name}</label>
                      <LinearProgress
                        color="secondary"
                        variant="determinate"
                        value={audioTrailerUploadProgress?.percent}
                      />
                    </Stack>
                  </li>
                )}
            </ul>
          </Grid>
        )}

        {formValidation != undefined && formValidation.length > 0 && (
          <Grid
            item
            xs={13}
            sx={{ backgroundColor: '#ddedff', margin: 5, borderRadius: 6 }}>
            <Grid item xs={12}>
              <div
                className="video_label-title_validation"
                style={{ marginTop: 10 }}>
                Campos obrigatórios não preenchidos!
              </div>
              <div className="video_label-title_validation_2">
                Por favor, preencha os campos abaixo para que seja possível
                publicar sua série:
              </div>
            </Grid>
            <div style={{ marginLeft: 15, marginBottom: 15 }}>
              {formValidation.map((items, index) => {
                return (
                  <li
                    key={index}
                    style={{ listStyleType: 'none', fontSize: 15 }}>
                    <ReportGmailerrorredIcon
                      fontSize="small"
                      sx={{ color: 'red' }}
                    />{' '}
                    {collecionFormValidation[items]}
                  </li>
                );
              })}
            </div>
          </Grid>
        )}
        <Grid item xs={4}></Grid>
        {viewFields && (
          <div>
            <Grid container spacing={2} sx={{ marginLeft: '0px' }}>
              <Grid item xs={12}>
                <div className="video_label-title">Confirmação</div>
              </Grid>
              <Grid item xs={12}>
                {(showStatus === 'CREATED' || showStatus === 'FAILED') && (
                  <div
                    className="confirmation_message"
                    id="collection-publish-transcode-inprogress">
                    <svg
                      width="67"
                      height="67"
                      viewBox="0 0 67 67"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <rect
                        x="5.50391"
                        y="5.5"
                        width="56"
                        height="56"
                        rx="12"
                        fill="#F2F4F7"
                      />
                      <path
                        d="M37.1602 31.875C36.5586 31.875 36.1289 31.4453 36.1289 30.8438V26.0312V24.6562C36.1289 24.0977 36.5586 23.625 37.1602 23.625H39.9102C40.4688 23.625 40.9414 24.0977 40.9414 24.6562V26.0312C40.9414 26.6328 40.4688 27.0625 39.9102 27.0625H38.1914V30.8438C38.1914 31.4453 37.7188 31.875 37.1602 31.875ZM27.1914 27.0625C24.9141 27.0625 23.0664 28.9102 23.0664 31.1875V38.75C23.0664 39.1367 23.3672 39.4375 23.7539 39.4375H31.3164V31.1875C31.3164 28.9102 29.4688 27.0625 27.1914 27.0625ZM31.7891 27.0625C32.7773 28.1797 33.3789 29.6406 33.3789 31.1875V39.4375H43.0039C43.3477 39.4375 43.6914 39.1367 43.6914 38.75V31.1875C43.6914 29.7266 42.875 28.3945 41.6719 27.6641C42.0586 27.2344 42.3164 26.6758 42.3164 26.0312V25.6445C44.3359 26.6758 45.7539 28.7812 45.7539 31.1875V38.75C45.7539 40.2969 44.5078 41.5 43.0039 41.5H33.3789H31.3164H23.7539C22.207 41.5 21.0039 40.2969 21.0039 38.75V31.1875C21.0039 27.793 23.7539 25 27.1914 25H34.7539V26.0312V27.0625H31.7891ZM25.4727 30.5H28.9102C29.4688 30.5 29.9414 30.9727 29.9414 31.5312C29.9414 32.1328 29.4688 32.5625 28.9102 32.5625H25.4727C24.8711 32.5625 24.4414 32.1328 24.4414 31.5312C24.4414 30.9727 24.8711 30.5 25.4727 30.5Z"
                        fill="#478bb0"
                      />
                      <rect
                        x="5.50391"
                        y="5.5"
                        width="56"
                        height="56"
                        rx="12"
                        stroke="#F9FAFB"
                        strokeWidth="10"
                      />
                    </svg>
                    <p>
                      Seu registro está em processamento e
                      <strong> assim que for concluído</strong>
                    </p>
                    <p>
                      <strong>enviaremos um e-mail com a confirmação</strong> da
                      publicação no aplicativo.
                    </p>
                  </div>
                )}
                {(showStatus === 'COMPLETE' || !getValues('trailerId')) && ( // todas as mídias completed
                  <div
                    className="confirmation_message"
                    id="collection-publish-transcode-complete">
                    <svg
                      width="67"
                      height="67"
                      viewBox="0 0 67 67"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <rect
                        x="5.50391"
                        y="5.88965"
                        width="56"
                        height="56"
                        rx="12"
                        fill="#F2F4F7"
                      />
                      <path
                        d="M32.9453 37.249C32.4727 37.7217 31.7422 37.7217 31.2695 37.249L28.5195 34.499C28.0469 34.0264 28.0469 33.2959 28.5195 32.8232C28.9922 32.3506 29.7227 32.3506 30.1953 32.8232L32.1289 34.7139L36.7695 30.0732C37.2422 29.6006 37.9727 29.6006 38.4453 30.0732C38.918 30.5459 38.918 31.2764 38.4453 31.749L32.9453 37.249ZM44.5039 33.6396C44.5039 39.7412 39.5625 44.6396 33.5039 44.6396C27.4023 44.6396 22.5039 39.7412 22.5039 33.6396C22.5039 27.5811 27.4023 22.6396 33.5039 22.6396C39.5625 22.6396 44.5039 27.5811 44.5039 33.6396ZM33.5039 24.7021C28.5625 24.7021 24.5664 28.7412 24.5664 33.6396C24.5664 38.5811 28.5625 42.5771 33.5039 42.5771C38.4023 42.5771 42.4414 38.5811 42.4414 33.6396C42.4414 28.7412 38.4023 24.7021 33.5039 24.7021Z"
                        fill="#008000"
                      />
                      <rect
                        x="5.50391"
                        y="5.88965"
                        width="56"
                        height="56"
                        rx="12"
                        stroke="#F9FAFB"
                        strokeWidth="10"
                      />
                    </svg>
                    <p>
                      Registro processado e <strong> concluído,</strong> a
                      série <strong> {getValues('title')} </strong> já está
                      disponível no aplicativo.
                    </p>
                  </div>
                )}
                {showStatus === 'ARCHIVED' && (
                  <div className="confirmation_message">
                    <svg
                      width="67"
                      height="67"
                      viewBox="0 0 67 67"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <rect
                        x="5.50391"
                        y="5.88965"
                        width="56"
                        height="56"
                        rx="12"
                        fill="#F2F4F7"
                      />
                      <path
                        d="M32.9453 37.249C32.4727 37.7217 31.7422 37.7217 31.2695 37.249L28.5195 34.499C28.0469 34.0264 28.0469 33.2959 28.5195 32.8232C28.9922 32.3506 29.7227 32.3506 30.1953 32.8232L32.1289 34.7139L36.7695 30.0732C37.2422 29.6006 37.9727 29.6006 38.4453 30.0732C38.918 30.5459 38.918 31.2764 38.4453 31.749L32.9453 37.249ZM44.5039 33.6396C44.5039 39.7412 39.5625 44.6396 33.5039 44.6396C27.4023 44.6396 22.5039 39.7412 22.5039 33.6396C22.5039 27.5811 27.4023 22.6396 33.5039 22.6396C39.5625 22.6396 44.5039 27.5811 44.5039 33.6396ZM33.5039 24.7021C28.5625 24.7021 24.5664 28.7412 24.5664 33.6396C24.5664 38.5811 28.5625 42.5771 33.5039 42.5771C38.4023 42.5771 42.4414 38.5811 42.4414 33.6396C42.4414 28.7412 38.4023 24.7021 33.5039 24.7021Z"
                        fill="#344054"
                      />
                      <rect
                        x="5.50391"
                        y="5.88965"
                        width="56"
                        height="56"
                        rx="12"
                        stroke="#F9FAFB"
                        strokeWidth="10"
                      />
                    </svg>
                    <p>
                      Seu registo já foi realizado e a
                      <strong> série foi incluída</strong>
                    </p>
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        )}
      </Grid>
    </div>
  );
}

export default SeriesStep7;


